import BaseApi from '../../../infraestructure/BaseApi';

export default class ApiStudents extends BaseApi {
    constructor(client, endPoint) {
        super(client, endPoint)
    }

    findByAccount(userId) {
        return this.client.get(`${this.endPoint}/${userId}/by-account`)
    }

    doRegister(data) {
        return this.client.put(`${this.endPoint}/do-register`, data)
    }

    doChangeStatus(data) {
        return this.client.put(`${this.endPoint}/do-change-status`, data)
    }
}